import { Fragment } from "react";
import { Item, ItemProps } from "./Item";

export interface ListProps {
  data?: Partial<Omit<ItemProps, "type">>[];
  type: "crypto" | "stock";
}
export const List = (props: ListProps) => {
  const { data, type } = props;
  if (typeof data === "undefined") {
    return (
      <Fragment>
        {Array.from({ length: 5 }).map((_, index) => (
          <Item key={index} />
        ))}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {data.map((item, index) => (
        <Item key={index} type={type} {...item} />
      ))}
    </Fragment>
  );
};
